import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import { AppContext } from "../context/context";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";

const HistoryLogs = () => {
  const { state, fetchLogs } = useContext(AppContext);
  const { logsData } = state;

  const [loading, setLoading] = useState(false);
  const [logsDataLocal, setLogsDataLocal] = useState(logsData);

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection"
    }
  ]);

  const [showCalendar, setShowCalendar] = useState(false);
  const [getForNudge, setGetForNudge] = useState(false);

  const getData = async () => {
    setShowCalendar(false);
    const { startDate, endDate } = dateRange[0];
    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates");
      return;
    }

    setLoading(true);
    const payload = {
      start_date: startDate.toString(),
      end_date: endDate.toString(),
      source: getForNudge
        ? "nudge"
        : state?.activeTab === "ABCD App"
        ? "abcd"
        : "service"
    };
    await fetchLogs(payload);
    setLoading(false);
  };

  useEffect(() => {
    setLogsDataLocal(logsData);
  }, [logsData]);

  return (
    <div className="h-[calc(100%_-_88px)] pb-2 mt-2">
      <div className="flex items-center justify-between">
        <p className="text-lg font-medium text-[#424242]">List of Analytics</p>
      </div>

      {/* Improved Date Filters + Fetch Button */}
      <div className="flex gap-4 mb-4 mt-4 items-start">
        <div className="flex flex-col">
          <div className="flex flex-col relative">
            <label className="text-sm text-gray-700 mb-1">Date Range</label>
            <div
              className="border px-3 py-1.5 rounded text-sm bg-white cursor-pointer w-72 shadow-sm"
              onClick={() => setShowCalendar(!showCalendar)}
            >
              {`${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(
                dateRange[0].endDate,
                "dd/MM/yyyy"
              )}`}
            </div>
            {showCalendar && (
              <div className="absolute top-20 z-50 shadow-md">
                <DateRange
                  editableDateInputs={true}
                  onChange={(item) => {
                    setDateRange([item.selection]);

                    const { startDate, endDate } = item.selection;
                    if (
                      startDate &&
                      endDate &&
                      startDate.getTime() !== endDate.getTime()
                    ) {
                      setShowCalendar(false);
                    }
                  }}
                  moveRangeOnFirstSelection={false}
                  ranges={dateRange}
                  maxDate={new Date()}
                />
              </div>
            )}
          </div>
          <div className="flex mt-[12px] gap-2 ">
            <input
              type="checkbox"
              checked={getForNudge}
              onChange={(e) => setGetForNudge(e.target.checked)}
              disabled={state?.activeTab !== "ABCD App"}
              className="w-5 h-5"
            />
            <label className="text-sm text-gray-700 mb-1">For Nudge Only</label>
          </div>
        </div>
        <button
          onClick={getData}
          className={`px-4 py-2 mt-[22px] rounded text-white text-sm transition ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-[#1C4EB2] hover:bg-[#163a8a]"
          }`}
          disabled={loading}
        >
          {loading ? "Loading..." : "Fetch"}
        </button>
      </div>

      <div className="flex flex-col gap-2 pt-[15px] h-[calc(100%_-_115px)]">
        <div className="h-full overflow-auto relative bg-white">
          <table className="w-full table-fixed min-w-[500px]">
            <tbody>
              <tr className="sticky top-0 z-[5]">
                <th className="border-[#EAECF0] p-3 bg-[#F8F8F8] text-start text-sm font-semibold w-[22rem]">
                  Parameter
                </th>
                <td className="border-[#EAECF0] p-3 bg-[#F8F8F8] text-start text-sm font-semibold">
                  Value
                </td>
              </tr>

              {Object.entries(logsDataLocal)?.length > 0 &&
                Object.entries(logsDataLocal).map((item, i) => (
                  <tr className="border-[2px] border-[#EAECF0]" key={i}>
                    <th className="border-[2px] border-[#e1e1e1] text-sm p-3 font-semibold text-start w-[22rem]">
                      {item[0]}
                    </th>
                    <td className="border-[2px] border-[#e1e1e1] text-sm p-3 text-start">
                      <p
                        className="text-ellipsis text-nowrap overflow-hidden"
                        title={item[1]}
                      >
                        {typeof item[1] === "string" &&
                        item[1].startsWith("http") ? (
                          <a
                            href={item[1]}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#2563eb] cursor-pointer"
                          >
                            {item[1]}
                          </a>
                        ) : (
                          item[1]
                        )}
                      </p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {logsDataLocal?.length === 0 && (
            <div className="h-[calc(100%_-_47px)] flex items-center justify-center">
              {loading ? (
                "Loading..."
              ) : (
                <img
                  className="h-2/3 min-h-24 max-h-48"
                  src={assetsManager.emptyIllustration}
                  alt="No Data"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoryLogs;
